import React, { useEffect, useState } from "react";
import { CheckIcon, KeyIcon, XCircleIcon } from "@heroicons/react/solid";
import { Col, Row, Card, Button, Modal, FormCheck, ToastContainer, InputGroup } from 'react-bootstrap';
import Select from 'react-select';
import CopyToClipboard from "react-copy-to-clipboard";
import { useCheckUserDetailsMutation, useGetVendorListMutation, useEditSmscAccountMutation } from "Services/services";
import { CiEdit } from "react-icons/ci";
import { Toast } from 'react-bootstrap';
import { SMSCRegistrationListTable } from "./Tables";
import { MdOutlineAutoMode } from "react-icons/md";
import TableWrapper from 'components/TableWrapper';

export const GeneralInfoForm = () => {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('success');
 
  const [editDetails, setEditDetails] = useState({});
  const [previewDetails, setPreviewDetails] = useState({});
  const [isValidated, setIsValidated] = useState(false);
  const [showEdit, setShowEdit] = useState(false)
  const [showEditDefault, setShowEditDefault] = useState(false);

  const [copied, setCopied] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [userDetailUpdates] = useEditSmscAccountMutation();
  const [verify] = useCheckUserDetailsMutation();
  const [isEditingPassword, setIsEditingPassword] = useState(false);
  const [isEditPassword, setIsEditPassword] = useState(false);
  const [refreshTable, setRefreshTable] = useState(false);
  const [users, setUsers] = useState([]);
  const [userDropDown] = useGetVendorListMutation();
  const [missingFields, setMissingFields] = useState([]);
  const fieldLabels = {
    vendor_name: 'Vendor',
    instances: 'Instances',
    'alt-charset': 'ALT-Charset',
    host: 'Host (IP Address)',
    port: 'Port',
    'smsc-username': 'SMSC Username',
    'smsc-password': 'Password',
    'source-addr-npi': 'Source-Addr-NPI',
    'source-addr-ton': 'Source-Addr-TON',
    'dest-addr-npi': 'Dest-Addr-NPI',
    'dest-addr-ton': 'Dest-Addr-TON',
    'transceiver-mode': 'Transceiver Mode',
    smsc_type: 'SMS Type',
    throughput: 'Throughput',
  };

  useEffect(()=> {
    const requiredFields = [
      'vendor_name',
      'instances',
      'alt-charset',
      'host',
      'port',
      'smsc-username',
      'source-addr-npi',
      'source-addr-ton',
      'dest-addr-npi',
      'dest-addr-ton',
      'transceiver-mode',
      'smsc_type',
      'throughput',
    ];

    const missing = requiredFields.filter((field) => {
      const value = editDetails?.[field];
      return value === undefined || value === null || String(value).trim() === '';
    });

    setMissingFields(missing);
    setIsValidated(missing.length === 0);
  }, [editDetails])

  const handleEdit = async (userDetails) => {
    try {
      const response = await userDropDown({ page: 1, limit: 1000, search: "" });
      if (response?.data?.statusCode === 200) {
        const items = response?.data?.data?.items || [];
        const userOptions = items.map((user) => ({
          value: user.id,
          label: user.vendor_name,
        }));
        setUsers(userOptions);
      } else {
        console.error("Failed to fetch user data", response);
      }
    } catch (error) {
      console.error("Error fetching user data", error);
    }

    setEditDetails(userDetails);
    setShowEdit(true);
  };

  const [isVerifiedUsername, setisVerifiedUsername] = useState();

  const verifyUsername = (e) => {
    const username = e.target.value;
    setEditDetails({ ...editDetails, "smsc-username": username })

    const regex = /^[a-zA-Z0-9._]{0,50}$/;

    if (username.length >= 3 && username.length <= 50 && regex.test(username)) {
      const postData = { data: username };
      verify(postData)
        .then((success) => {
          if (success?.data?.statusCode === 200) {
            setisVerifiedUsername(true);
          } else if (success?.data?.statusCode > 300) {
            setisVerifiedUsername(false);
          }
        })
        .catch((error) => {
          setisVerifiedUsername(false);
        });
    } else {
      setisVerifiedUsername(false);
    }
  };

  const [passwordError, setPasswordError] = useState(false);
  const handlePasswordChange = (e) => {
    const newValue = e.target.value;
    // Limit length and allow valid characters
    if (newValue.length <= 32) {
      // Validate live feedback
      const isValid = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^])[A-Za-z\d@$!%*?&#^]{8,32}$/.test(newValue);
      setPasswordError(!isValid);
      setEditDetails({ ...editDetails, "smsc-password": newValue });
    }
  };
  const generatePassword = () => {
    const length = 12;
    const lower = "abcdefghijklmnopqrstuvwxyz";
    const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const numbers = "0123456789";
    const symbols = "@$!%*?&#^";
  
    const all = lower + upper + numbers + symbols;
  
    let newPassword = "";
    newPassword += lower[Math.floor(Math.random() * lower.length)];
    newPassword += upper[Math.floor(Math.random() * upper.length)];
    newPassword += numbers[Math.floor(Math.random() * numbers.length)];
    newPassword += symbols[Math.floor(Math.random() * symbols.length)];
  
    for (let i = 4; i < length; i++) {
      newPassword += all[Math.floor(Math.random() * all.length)];
    }
  
    // Shuffle newPassword to remove predictable pattern
    newPassword = newPassword
      .split("")
      .sort(() => 0.5 - Math.random())
      .join("");
  
    setEditDetails({...editDetails, "smsc-password": newPassword});
    setPasswordError(false);
  };

  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const handleClose = () => {
    setShowEdit(false);
    setShowEditDefault(false);
  }

  const handleCloseBack = () => {
    setShowEditDefault(false);
    setShowEdit(true);
  }

  const handleEditSubmit = (e) => {
    e.preventDefault();

    const payload = {
      smsc_id: editDetails["smsc-id"],
      vendor: editDetails.vendor_name,
      instances: editDetails.instances,
      alt_charset: editDetails["alt-charset"],
      host: editDetails.host,
      port: editDetails.port,
      smsc_username: editDetails["smsc-username"],
      smsc_password: editDetails["smsc-password"],
      source_addr_npi: editDetails["source-addr-npi"],
      source_addr_ton: editDetails["source-addr-ton"],
      dest_addr_npi: editDetails["dest-addr-npi"],
      dest_addr_ton: editDetails["dest-addr-ton"],
      transceiver_mode: editDetails["transceiver-mode"],
      smsc_type: editDetails["smsc_type"],
      throughput: editDetails.throughput,
    };

    setPreviewDetails(payload);
    setShowEdit(false);
    setShowEditDefault(true);
  }

  const submitEditForm = (e) => {
    e.preventDefault();

    // to send id in vendor
    const vendor = users.find(u => String(u.label) === String(editDetails.vendor_name)).value;

    const editedPostData = {
      ...previewDetails,
      vendor: vendor,
      user_chain: editDetails?.user_chain,
      user_id: editDetails?.user_id,
      system_type: editDetails["system-type"] || "SMPP",
    };

    userDetailUpdates(editedPostData)
    .then((res) => {
      // If using RTK Query style response
      if (res.error) {
        console.log("error", res.error);
        setToastMessage(res.error?.data?.message || "Error Updating User details!");
        setToastVariant("danger");
      } else if (res.data?.statusCode === 200) {
        setShowEdit(false);
        setShowEditDefault(false);
        setEditDetails([]);
        setRefreshTable(!refreshTable);
        setToastMessage(res.data?.message || "User details Updated!");
        setToastVariant("success");
      } else {
        setToastMessage(res.data?.message || "Error Updating User details!");
        setToastVariant("danger");
      }
    })
    .catch((error) => {
      console.log("catch error", error);
      setToastMessage(error?.data?.message || "Error Updating User details!");
      setToastVariant("danger");
    })
    .finally(() => {
      setShowToast(true);
    });  
  };

  return (
    <>
      <ToastContainer position="top-end" className="p-3">
        <Toast
          bg={toastVariant}
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>

      <div>
        <Modal backdrop="static" size="lg" keyboard={false} as={Modal.Dialog} centered show={showEdit} onHide={handleClose}>
          <Modal.Header>
            <Modal.Title className="h6">Edit User Details</Modal.Title>
            <Button variant="close" aria-label="Close" onClick={handleClose} />
          </Modal.Header>
          <Modal.Body>
            <div className="mb-2 mt-2">
              <Row>
                <Col md={12}>
                  <TableWrapper>
                    <tbody>
                      <tr>
                        <td className="border-0">Vendor</td>
                        <td className="border-0">
                          <Select
                            options={users}
                            placeholder="Select Vendor"
                            className="mb-0"
                            isSearchable={true}
                            //getting label from table 
                            value={users.find(u => String(u.label) === String(editDetails.vendor_name)) || null}
                            onChange={(selectedOption) => {
                              setEditDetails({ ...editDetails, vendor_name: selectedOption.label });
                            }
                          }
                             // Ensure the dropdown appears over the card
                            menuPortalTarget={document.body} // Attach the dropdown to the body
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                borderRadius: '0.75rem',
                              }),
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }), // High z-index
                            }}
   
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Instances</td>
                        <td className="border-0">
                          <input
                            required
                            type="text"
                            placeholder="Enter Instances"
                            value={editDetails.instances || ""}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (val === "" || /^\d{1,4}$/.test(val)) {
                                setEditDetails({ ...editDetails, instances: val });
                              }
                            }}
                            className="form-control"
                            title="Instances must be a 1-4 digit positive number"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">ALT-Charset</td>
                        <td className="border-0">
                          <Select
                            options={[
                              { value: "UTF-8", label: "UTF-8" },
                              { value: "GSM-7", label: "GSM-7" },
                              { value: "ASCII", label: "ASCII" },
                              { value: "Default", label: "Default" },
                            ]}
                            placeholder="Select alt-charset"
                            className="mb-0"
                            isSearchable={true}
                            value={editDetails["alt-charset"]
                              ? { value: editDetails["alt-charset"], label: editDetails["alt-charset"] }
                              : null}
                            onChange={(selectedOption) => setEditDetails({ ...editDetails, "alt-charset": selectedOption?.value })}
                            menuPortalTarget={document.body} // Attach the dropdown to the body
                            styles={{
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }), // High z-index
                           
                              control: (provided) => ({
                                ...provided,
                                borderRadius: '0.75rem',
                              }),
                            }}
                             // Ensure the dropdown appears over the card
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Host (IP Address)</td>
                        <td className="border-0">
                          <div className="d-flex gap-1">
                            {[0, 1, 2, 3].map((index) => (
                              <input
                                key={index}
                                type="text"
                                value={(() => {
                                  const ipParts = editDetails.host ? editDetails.host.split('.') : ["", "", "", ""];
                                  return ipParts[index] || "";
                                })()}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  if (val === "" || (/^\d{1,3}$/.test(val) && +val <= 255)) {
                                    const currentParts = editDetails.host ? editDetails.host.split('.') : ["", "", "", ""];
                                    const newParts = [...currentParts];
                                    newParts[index] = val;
                                    setEditDetails({ ...editDetails, host: newParts.join('.') });
                                  }
                                }}
                                style={{ width: "60px", textAlign: "center" }}
                                className="form-control"
                                maxLength={3}
                                placeholder="0"
                              />
                            ))}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Port</td>
                        <td className="border-0">
                          <input
                            type="number"
                            placeholder="Enter Port"
                            min={0}
                            max={65535}
                            value={editDetails.port || ""}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (val === "" || /^\d+$/.test(val)) {
                                setEditDetails({ ...editDetails, port: val });
                              }
                            }}
                            className="form-control"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">SMSC Username</td>
                        <td className="border-0">
                          <InputGroup>
                          <input
                            type="text"
                            placeholder="Enter Username"
                            value={editDetails["smsc-username"]}
                            onChange={verifyUsername}
                            className="form-control"
                            minLength={3}
                            maxLength={50}
                            title="Username must be 3–50 characters, no special characters except _ and ."
                          />
                           {isVerifiedUsername && (
                              <InputGroup.Text title="Username is available and unique">
                                <CheckIcon width={20} className="text-success" />
                              </InputGroup.Text>
                            )}
                            {isVerifiedUsername === false && (
                              <InputGroup.Text title="Username is not available or unique">
                                <XCircleIcon width={20} className="text-danger" />
                              </InputGroup.Text>
                            )}
                            </InputGroup>
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Password</td>
                        <td className="border-0">
                          <div className="input-group">
                            {isEditPassword ? (
                              <>
                                <span className="input-group-text">
                                  <KeyIcon width={20} />
                                </span>
                                <input
                                  required
                                  type="password"
                                  maxLength={32}
                                  placeholder="Password"
                                  autoComplete="new-password"
                                  value={editDetails["smsc-password"]}
                                  title="Password must be 8-32 characters, include uppercase, lowercase, number, and special character."
                                  onChange={handlePasswordChange}
                                  className={`form-control ${passwordError ? "is-invalid" : ""}`}
                                />
                                                                <span
                                  className="input-group-text"
                                  onClick={generatePassword}
                                  style={{ cursor: 'pointer' }}
                                  title="Auto-generate password"
                                >
                                  <MdOutlineAutoMode size={20} />
                                </span>
                              </>
                            ) : (
                              <Button variant="light" onClick={() => setIsEditingPassword(!isEditingPassword)}>
                                <CiEdit size={25} />
                              </Button>
                            )}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Source-Addr-NPI</td>
                        <td className="border-0">
                          <input
                            type="text"
                            placeholder="Enter Addr-NPI"
                            value={editDetails["source-addr-npi"] || ""}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (val === "" || /^\d{1,4}$/.test(val)) {
                                setEditDetails({ ...editDetails, "source-addr-npi": val });
                              }
                            }}
                            className="form-control"
                            title="Source-Addr-Npi must be a 1-4 digit positive number"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Source-Addr-TON</td>
                        <td className="border-0">
                          <input
                            type="text"
                            placeholder="Enter Addr-TON"
                            value={editDetails["source-addr-ton"] || ""}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (val === "" || /^\d{1,4}$/.test(val)) {
                                setEditDetails({ ...editDetails, "source-addr-ton": val });
                              }
                            }}
                            className="form-control"
                            title="Source-Addr-Ton must be a 1-4 digit positive number"
                          />
                        </td>
                      </tr>
                     
                      <tr>
                        <td className="border-0">Dest-Addr-NPI</td>
                        <td className="border-0">
                          <input
                            type="number"
                            placeholder="Enter Addr-NPI"
                            value={editDetails["dest-addr-npi"] || ""}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (val === "" || /^\d{1,4}$/.test(val)) {
                                setEditDetails({ ...editDetails, "dest-addr-npi": val });
                              }
                            }}
                            className="form-control"
                            title="Dest-Addr-Npi must be a 1-4 digit positive number"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Dest-Addr-TON</td>
                        <td className="border-0">
                          <input
                            type="number"
                            placeholder="Enter Addr-TON"
                            value={editDetails["dest-addr-ton"] || ""}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (val === "" || /^\d{1,4}$/.test(val)) {
                                setEditDetails({ ...editDetails, "dest-addr-ton": val });
                              }
                            }}
                            className="form-control"
                            title="Dest-Addr-Ton must be a 1-4 digit positive number"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Transceiver Mode</td>
                        <td className="border-0">
                          <Select
                            options={[
                              { value: "TX", label: "TX" },
                              { value: "RX", label: "RX" },
                              { value: "TRX", label: "TRX" }
                            ]}
                            placeholder="Select Transceiver Mode"
                            className="mb-0"
                            isSearchable={true}
                            value={editDetails["transceiver-mode"]  ? { value: editDetails["transceiver-mode"], label: editDetails["transceiver-mode"] }
                            : null}
                            onChange={(selectedOption) => setEditDetails({ ...editDetails, "transceiver-mode": selectedOption?.value })}
                            menuPortalTarget={document.body} // Attach the dropdown to the body
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                borderRadius: '0.75rem',
                              }),
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }), // High z-index
                            }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">SMS Type</td>
                        <td className="border-0">
                          <Select
                            options={[
                              { value: "Domestic", label: "Domestic" },
                              { value: "International", label: "International" }
                            ]}
                            placeholder="Select SMS Type"
                            className="mb-0"
                            isSearchable={true}
                            value={editDetails["smsc_type"] ? {value: editDetails["smsc_type"], label: editDetails["smsc_type"]} : null}
                            onChange={(selectedOption) => setEditDetails({ ...editDetails, "smsc_type": selectedOption?.value })}
                            menuPortalTarget={document.body} // Attach the dropdown to the body
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                borderRadius: '0.75rem',
                              }),
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }), // High z-index
                            }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Throughput</td>
                        <td className="border-0">
                          <input
                            type="number"
                            placeholder="Enter Throughput"
                            value={editDetails.throughput || ""}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (val === "" || /^\d{1,4}$/.test(val)) {
                                setEditDetails({ ...editDetails, throughput: val });
                              }
                            }}
                            max={1000}
                            className="form-control"
                            title="Throughput must be a 1-4 digit positive number, max 1000"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </TableWrapper>
                  {missingFields.length > 0 && (
                    <div className="mt-2">
                      <div className="fw-bold mb-1">Please fill the following required fields:</div>
                      <ul className="mb-0">
                        {missingFields.map((f) => (
                          <li key={f}>{fieldLabels[f] || f}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleEditSubmit} disabled={!isValidated || (isEditPassword && (!!passwordError || !editDetails["smsc-password"]))}>
              Preview
            </Button>
          </Modal.Footer>
        </Modal>

{/* password confirmation */}
        <Modal backdrop="static" keyboard={false} as={Modal.Dialog} centered show={isEditingPassword && !isEditPassword} onHide={handleClose}>
          <Modal.Header>
            <Modal.Title className="h6">Edit Password Confirmation</Modal.Title>
            <Button variant="close" aria-label="Close" onClick={() => setIsEditingPassword(!isEditingPassword)} />
          </Modal.Header>
          <Modal.Body>
            <p>Once confirmed, you will be required to update your password.</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => {
              setIsEditPassword(!isEditPassword);
              setEditDetails((prevDetails) => ({
                ...prevDetails,
                password: ""
              }));
            }}>
              Confirm
            </Button>
            <Button variant="link" className="text-gray ms-auto" onClick={() => setIsEditingPassword(!isEditingPassword)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {/* preview modal */}
        <Modal backdrop="static" keyboard={false} as={Modal.Dialog} centered show={showEditDefault} onHide={handleCloseBack}>
          <Modal.Header>
            <Modal.Title className="h6">Editted User Detail Preview</Modal.Title>
            <Button variant="close" aria-label="Close" onClick={handleCloseBack} />
          </Modal.Header>
          <Modal.Body>
            <Card className="mb-2 mt-2">
              <Row>
                <Col md={10}>
                  <TableWrapper>
                    <tbody>
                       {Object.entries(previewDetails || {})
                        .map(([key, value]) => (
                         <tr key={key}>
                           <td className="border-0 text-capitalize">{key==="smsc_type"?"SMS Type":String(key).split("_").join(" ")}</td>
                           <td className="border-0" title={String(value)}>
                             {String(key).toLowerCase().includes('password') ? '********' : String(value)}
                           </td>
                         </tr>
                       ))}
                    </tbody>
                  </TableWrapper>
                </Col>
                <Col md={2} className="d-flex align-items-start">
                  <Card.Body className="d-flex flex-column">
                    <div>
                      {copied ? (
                        <Button size="sm" variant="success" className="copy-code-button">
                          Copied
                        </Button>
                      ) : (
                        <CopyToClipboard
                          text={Object.entries(previewDetails)
                            .map(([key, value]) => `${key}: ${value}`)
                            .join("\n")}
                          onCopy={handleCopy}
                        >
                          <Button size="sm" variant="secondary" className="copy-code-button">
                            Copy
                          </Button>
                        </CopyToClipboard>
                      )}
                    </div>
                  </Card.Body>
                </Col>
              </Row>
            </Card>

            <Card className="mb-2 mt-3">
              <Row>
                <Col md={12}>
                    <b>Share Details:</b>
                    <FormCheck type="switch" className="mt-2">
                      <FormCheck.Input
                        type="checkbox"
                        id="emailSwitch"
                        checked={selectedOption === 'email'}
                        onChange={() => setSelectedOption('email')}
                      />
                      <FormCheck.Label htmlFor="emailSwitch" style={{ marginLeft: '8px' }}>
                        Email ID
                      </FormCheck.Label>
                    </FormCheck>
                    <FormCheck type="switch" className="mt-2">
                      <FormCheck.Input
                        type="checkbox"
                        id="phoneSwitch"
                        checked={selectedOption === 'phone'}
                        onChange={() => setSelectedOption('phone')}
                      />
                      <FormCheck.Label htmlFor="phoneSwitch" style={{ marginLeft: '8px' }}>
                        Phone Number
                      </FormCheck.Label>
                    </FormCheck>
                    <FormCheck type="switch" className="mt-2">
                      <FormCheck.Input
                        type="checkbox"
                        id="bothSwitch"
                        checked={selectedOption === 'both'}
                        onChange={() => setSelectedOption('both')}
                      />
                      <FormCheck.Label htmlFor="bothSwitch" style={{ marginLeft: '8px' }}>
                        Both
                      </FormCheck.Label>
                    </FormCheck>
                    <FormCheck type="switch" className="mt-2">
                      <FormCheck.Input
                        type="checkbox"
                        id="noneSwitch"
                        checked={selectedOption === ''}
                        onChange={() => setSelectedOption('')}
                      />
                      <FormCheck.Label htmlFor="noneSwitch" style={{ marginLeft: '8px' }}>
                        None
                      </FormCheck.Label>
                    </FormCheck>
                </Col>
              </Row>
            </Card>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={(e) => submitEditForm(e)}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>

      <SMSCRegistrationListTable key={refreshTable} handleEdit={handleEdit} />
    </>
  );
};
